import { Box, Dialog, Divider, IconButton, Typography, Radio, RadioGroup, FormControlLabel, Grid, Autocomplete, TextField, useTheme, useMediaQuery } from '@mui/material';
import KenColors from '../../../utils/kenColors';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { AppButton } from '../../../globalComponent/AppButton';
import moment from 'moment';
import { locationDetails, sessionDetails, speakerDetails } from '../../../utils/formJson';
import { useAppFormContext } from '../../../utils/formContext';
import { createSession, deleteSession, deleteSpeaker, getSessionDetails, updateSession } from '../../../utils/services';
import { useEffect, useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import KenLoader from '../../../globalComponent/KenLoader';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { FormBuilder } from '../../../globalComponent/FormBuilder';
import { Controller, useForm, useFormContext } from 'react-hook-form';
import { EventFormValues, SessionsOperation } from '../../../utils/interfaces';
import { generateUniqueKey, getUniqueObjects, removeNullKeys, shrinkTextBased, splitBase64 } from '../../../utils/helpers';
import { useLocation } from 'react-router-dom';
import KenInput from '../../../globalComponent/KenInput';
import { REGEX } from '../../../../../Helpers/constant';
import { useStyles } from '../../../globalComponent/FormBuilder/styles';
import { useStyles as eventStyles } from '../../../styles';
import { createContact, getEventsData } from '../../../../../Utils/apiService';
import KenTextLabel from '../../../globalComponent/KenTextLabel';
import CloseIcon from '@mui/icons-material/Close';
import { time } from 'console';

const feeOptions = [
  {
    label: 'Session-wise pricing for the event',
    value: 'Session-wise Pricing',
  },
  {
    label: 'Overall pricing for the entire event',
    value: 'Overall Pricing',
  },
];

const Sessions: React.FunctionComponent<SessionsOperation> = (props) => {
  const {
    handleFeeTypeModal,
    feeType,
    setFeeType,
    feeTypeModal,
    handleNextStepper,
    speakerDetailsData,
    selectedDate,
    sessionDate,
    handleChangeDate,
    sessionDetailsData,
    handleFormTrigger,
    setSessionDetailsData,
  } = props;
  const {
    state: { options, files, range },
    dispatch,
  } = useAppFormContext();
  const [processedValue, setProcessedValue] = useState<any[]>([]);
  console.log(processedValue,sessionDate,"processedValueprocessedValueprocessedValue");
  
  const {
    control,
    register: registers,
    getValues,
    trigger,
    formState: { errors },
    setValue,
    reset,
    watch,
  } = useFormContext();
  console.log(getValues(), "setValuesetValuesetValuesetValue");

  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const eventId = searchParams.get('eventId');
  const { trigger: contactTrigger, control: contactControl, getValues: contactValues } = useForm<any>();
  const classes = useStyles();
  const eventClasses = eventStyles();

  const [loading, setLoading] = useState<boolean>(false);
  const [allContacts, setAllContacts] = useState<any>([]);
  console.log(allContacts,"allContactsallContacts");
  
  const [createContactState, setCreateContactState] = useState<any>({});
  const [newContact, setNewContact] = useState<boolean>(false);
  const [Timezone, setTimezone] = useState<any>([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  useEffect(() => {
    setLoading(true);
      getEventsData()
        .then(async (res) => {
          if (res.status === 'true' && res?.result && typeof res.result === 'string') {
            try {
              const eventData = JSON.parse(res.result)?.find((items: any) => {
                return items.Id === eventId;
              });
            const suitableForOptions = eventData?.timezone
              ?.split(';')
              .map((item: string) => ({
                label: item,
                value: item,
              })) || [];
            setTimezone(suitableForOptions);
            setLoading(false);
          } catch (error) {
            console.error('Error parsing event data:', error);
            setLoading(false);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        return enqueueSnackbar('Something went wrong', { variant: 'error' });
      });
  }, [eventId]);
  
  const [customSessionForms, setCustomSessionForms] = useState<any[]>([]);
  const [customLocationdetails, setCustomLocationdetails] = useState<any[]>([]);
  
  // Debug logging for customSessionForms
  useEffect(() => {
    if (customSessionForms) {
      console.log('Sessions - customSessionForms updated:', customSessionForms);
    }
  }, [customSessionForms]);

  useEffect(() => {
    getSessionDetails(eventId as string)
      .then((sessionContacts) => {
        const contacts = sessionContacts.result && typeof sessionContacts.result === 'string' ? JSON.parse(sessionContacts.result)?.contacts : [];
        console.log(contacts,"contactscontactscontactscontactscontactscontacts");
        
        const customContacts = contacts.map((items: any) => {
          const contact = { 
            value: items?.Id, 
            label: items?.FirstName ? `${items.FirstName} ${items.LastName}`.trim() : items?.LastName || 'Unknown'
          };
          console.log('Mapping contact:', items, 'to:', contact);
          return contact;
        });
        console.log('Setting contacts in state:', customContacts);
        setAllContacts(customContacts);
        dispatch({
          type: 'updateOptions',
          value: {
            fieldName: 'contacts',
            selectOptions: customContacts,
          },
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, [eventId]);

  // Trigger form update when contacts are loaded
  useEffect(() => {
    if (allContacts.length > 0) {
      console.log('Contacts loaded, triggering form update');
      handleFormTrigger();
    }
  }, [allContacts]);

  const handleNewContact = () => {
    setNewContact(!newContact);
  };

  const closeNewContact = () => {
    setNewContact(false);
  };

  const handleDeleteSpeakers = (data: any, uniqueId: string) => {
    let customSessionsDetailsData = { ...sessionDetailsData };
    let customSessionData = sessionDetailsData[sessionDate]?.sessions ? [...sessionDetailsData[sessionDate].sessions] : [];
    for (let i = 0; i < customSessionData.length; i++) {
      let speakers = customSessionData[i]?.speakers || [];
      let compareData = data[`speakerName-${sessionDate}-${uniqueId}`] || null;
      const speakerIndex = speakers.findIndex((items: any) => {
        let speakerName = items[`speakerName-${sessionDate}-${uniqueId}`];
        return speakerName === compareData;
      });
      dispatch({ type: 'removeFiles', value: { fieldName: `speakerImage-${sessionDate}-${uniqueId}` } });
      if (speakerIndex >= 0) {
        speakers.splice(speakerIndex, 1);
      }
    }
    const newArray = customSessionData.map((items: any) => {
      return {
        ...items,
        speakers: items?.speakers?.filter((subItems: any) => {
          return Object.keys(subItems).length !== 0;
        }),
      };
    });
    customSessionsDetailsData[sessionDate].sessions = newArray;
    setSessionDetailsData({ ...customSessionsDetailsData });
  };

  const handleCreateNewContact = async (data: any) => {
    const validateFieldsCount: boolean[] = [];
    for (const keys in data) {
      const isValid = await contactTrigger(keys);
      if (!isValid) validateFieldsCount.push(false);
    }

    if (validateFieldsCount.length > 0) {
      enqueueSnackbar('Please fill all the required fields', { variant: 'error' });
      return;
    }

    setLoading(true);
    await createContact(data)
      .then(async (res) => {
        if (res?.success) {
          await getSessionDetails(eventId as string)
            .then(async (sessionContacts) => {
              const contacts = sessionContacts.result && typeof sessionContacts.result === 'string' ? JSON.parse(sessionContacts.result)?.contacts : [];
              console.log(sessionContacts.result && typeof sessionContacts.result === 'string' ? JSON.parse(sessionContacts.result) : null, "contactscontacts");
              
              const customContacts = contacts.map((items: any) => {
                return { value: items?.Id, label: items?.FirstName ? items?.FirstName : items?.LastName };
              });
              setAllContacts(customContacts);
              dispatch({
                type: 'updateOptions',
                value: {
                  fieldName: 'contacts',
                  selectOptions: customContacts,
                },
              });
              let customValues = { ...createContactState?.speakerValues };
              customValues[`speakerName-${sessionDate}-${createContactState?.id}`] = res?.data?.Id;
              await new Promise((resolve) => setTimeout(resolve, 2000));
              setLoading(false);
              reset(customValues);
              handleCreateSpeakers(createContactState?.customSpeakerDetails, createContactState?.mainIndex, createContactState?.id, customContacts, customValues);
              handleNewContact();
            })
            .catch((err) => {
              setLoading(false);
              console.error(err);
            });
        }
      })
      .catch((err) => {
        setLoading(false);
        return enqueueSnackbar('Something went wrong', { variant: 'error' });
      });
  };

  const handleCreateSpeakers = async (
    customSpeakerDetails: Array<any>,
    mainIndex: number,
    id: string,
    contacts?: any,
    newValues?: any
  ): Promise<void> => {

    const speakerValues = newValues ?? { ...getValues() };
    const validateFieldsCount: boolean[] = [];
    const currentSpeakerValues: Record<string, any> = {};
    let hasContact = true;
    const currentSessionSpeakers = sessionDetailsData[sessionDate]?.sessions[mainIndex]?.speakers || [];
    const newSpeakerId = speakerValues[`speakerName-${sessionDate}-${id}`];
    const duplicateSpeaker = currentSessionSpeakers.find(
      (speaker: any) => speaker[`speakerName-${sessionDate}-${speaker.speakerId}`] === newSpeakerId
    );
    if (duplicateSpeaker) {
      console.log(duplicateSpeaker, "duplicateSpeakerduplicateSpeaker");

      // Find the key that starts with "speakerName"
      const speakerKey = Object.keys(duplicateSpeaker).find((key) => key.startsWith("speakerName"));
      if (!speakerKey || !duplicateSpeaker[speakerKey]) {
        // enqueueSnackbar('Please add a speaker!', { variant: 'error' });
      } else {
        enqueueSnackbar('The speaker is already added to this session!', { variant: 'error' });
        return;
      }
    }
    for (const detail of customSpeakerDetails) {
      for (const row of detail.rows) {
        for (const field of row.fields) {
          const fieldName = field.name;
          if (`speakerName-${sessionDate}-${id}` === fieldName) {
            hasContact = (contacts ?? allContacts)?.some((item: any) => item.value === speakerValues[fieldName]);
          }
          currentSpeakerValues[fieldName] = speakerValues[fieldName];
        }
      }
    }

    for (const key in currentSpeakerValues) {
      const isValid = await trigger(key as string);
      if (!isValid) validateFieldsCount.push(false);
    }

    if (validateFieldsCount.length > 0) {
      enqueueSnackbar('Please fill all the required fields', { variant: 'error' });
      return;
    }

    if (!hasContact) {
      setCreateContactState({ customSpeakerDetails, mainIndex, id, speakerValues });
      handleNewContact();
      enqueueSnackbar('The name you entered is not in contacts, so please create one!', { variant: 'error' });
      return;
    }

    if (validateFieldsCount.length === 0) {
      const updatedSessions = [...sessionDetailsData[sessionDate].sessions];
      const sessionSpeakers =
        (updatedSessions[mainIndex]['speakers'] || [])?.map((speakers: any) => {
          if (speakers?.speakerId === id) {
            speakers = { ...speakers, ...currentSpeakerValues };
          }
          return { ...speakers, edit: false };
        }) || [];

      updatedSessions[mainIndex]['speakers'] = [...sessionSpeakers];

      setSessionDetailsData((prev: any) => ({
        ...prev,
        [sessionDate]: { sessions: updatedSessions },
      }));
    }
  };

  const handleDeleteSession = async (id: string) => {
    setLoading(true);
    await deleteSession({ ids: [id] })
      .then((res) => {
        if (res.success === 'true') {
          handleFormTrigger();
          setLoading(false);
          return enqueueSnackbar('Session deleted successfully', { variant: 'success' });
        } else {
          setLoading(false);
          return enqueueSnackbar('Something went wrong', { variant: 'error' });
        }
      })
      .catch((err) => {
        setLoading(false);
        return enqueueSnackbar('Something went wrong', { variant: 'error' });
      });
  };

  const handleCreateSessions: (forms: Array<any>, id: string, items: any) => Promise<void> = async (forms, id, items) => {
    const SessionValues: any = { ...getValues() };
    let currentSessionValues: any = {};
    const validateFieldsCount = [];
    const requiredFields = [`sessionTitle-${sessionDate}-${id}`, `sessionAgenda-${sessionDate}-${id}`, `sessionTimeRange-${sessionDate}-${id}`, `locationType-${sessionDate}-${id}`];
    
    // Debug logging
    console.log('Sessions - handleCreateSessions called with:', {
      forms,
      id,
      sessionDate,
      requiredFields,
      SessionValues,
      allFormValues: getValues()
    });

    for (let i = 0; i < forms.length; i++) {
      const rows = forms[i].rows;
      for (let j = 0; j < rows.length; j++) {
        const fields = rows[j].fields;
        for (let k = 0; k < fields.length; k++) {
          const element = fields[k];
          let customName = (element?.name || '').split('-')?.length > 0 ? element.name.split('-')[0] : element.name;
          currentSessionValues[customName] = SessionValues[element.name as any];
          
          // Debug logging for time range fields
          if (element.type === 'timeRange') {
            console.log('Sessions - Processing time range field:', {
              originalName: element.name,
              customName,
              formValue: SessionValues[element.name as any],
              element
            });
          }
        }
      }
    }
    
    console.log('Sessions - currentSessionValues after processing:', currentSessionValues);

    for (const key of requiredFields) {
      console.log('Sessions - Triggering validation for field:', key);
      const data = await trigger(key as string);
      console.log('Sessions - Validation result for field:', key, 'result:', data);
      if (!data) {
        validateFieldsCount.push(data);
      }
    }

    if (validateFieldsCount.length === 0) {
      // Payload setup
      for (const key in files) {
        currentSessionValues[key] = files[key].data;
      }
      for (const key in range) {
        currentSessionValues[key] = range[key];
      }

      // Validate and format time values safely
      const timeRangeKey = `sessionTimeRange-${sessionDate}-${id}`;
      const timeRangeData = range[timeRangeKey] as any;
      let startTimeValue = timeRangeData?.startTime;
      let endTimeValue = timeRangeData?.endTime;
      
      // Fallback: Check if time range values exist in form state
      if (!startTimeValue || !endTimeValue) {
        const formValues = getValues();
        const timeRangeFormData = formValues[timeRangeKey];
        if (timeRangeFormData) {
          startTimeValue = timeRangeFormData.startTime || startTimeValue;
          endTimeValue = timeRangeFormData.endTime || endTimeValue;
        }
      }
      
      // Debug logging
      console.log('Time range debug:', {
        timeRangeKey,
        timeRangeData,
        startTimeValue,
        endTimeValue,
        rangeKeys: Object.keys(range),
        currentSessionValues,
        formValues: getValues(),
        timeRangeFormData: getValues()[timeRangeKey]
      });
      
      if (!startTimeValue || !endTimeValue) {
        throw new Error('Start time and end time are required');
      }
      
      let startTimess, endTimess;
      try {
        startTimess = new Date(`1970-01-01T${startTimeValue}-05:30`).toISOString().split('T')[1].split('Z')[0];
        endTimess = new Date(`1970-01-01T${endTimeValue}-05:30`).toISOString().split('T')[1].split('Z')[0];
      } catch (error) {
        console.error('Invalid time format:', { startTimeValue, endTimeValue });
        throw new Error('Invalid time format. Please check your time inputs.');
      }

      const sessionPayload = {
        Id: items?.Id,
        sessionTitle: currentSessionValues?.sessionTitle,
        agenda: currentSessionValues?.sessionAgenda,
        startDate: sessionDate,
        endDate: sessionDate,
        locationAddress: currentSessionValues?.locationAddress,
        locationType: currentSessionValues?.locationType,
        sessionLink: currentSessionValues?.sessionLink,
        startTime: startTimess,
        endTime: endTimess,
        timezone: currentSessionValues?.timezone,
        sessionBroucher: currentSessionValues?.[`${'sessionBroucher'}-${sessionDate}-${id}`] ? splitBase64(currentSessionValues?.[`${'sessionBroucher'}-${sessionDate}-${id}`]) : '',
        eventReference: eventId,
        speakers: items?.speakers
          ?.filter((items: any) => {
            return Object.keys(items).length > 2;
          })
          .map((speaker: any, index: number) => {
            const returnCustomName = (name: string) => {
              return `${name}-${sessionDate}-${speaker?.speakerId}`;
            };

            speaker['speakerImage'] = files[returnCustomName('speakerImage')]?.data ? splitBase64(files[returnCustomName('speakerImage')].data) : '';
            speaker['speakerName'] = speaker[returnCustomName('speakerName')];
            speaker['descriptionAboutTheSpeaker'] = speaker[returnCustomName('descriptionAboutTheSpeaker')];
            speaker['Id'] = speaker?.Id;

            delete speaker[returnCustomName('speakerImage')];
            delete speaker[returnCustomName('speakerName')];
            delete speaker[returnCustomName('descriptionAboutTheSpeaker')];

            return { ...speaker };
          }),
      };
      setLoading(true);
      const sessionNewPayload = removeNullKeys(sessionPayload);
      try {
        if (sessionNewPayload?.Id) {
          const existingSpeaker = sessionPayload?.speakers;
          const currentSessionSpeakers =
            speakerDetailsData[sessionDate as any]?.sessions?.find((items: any) => {
              return items?.Id === sessionNewPayload?.Id;
            })?.speakers || [];
          const data = getUniqueObjects(currentSessionSpeakers, existingSpeaker);
          for (let i = 0; i < data.length; i++) {
            const element = data[i];
            await deleteSpeaker(element?.Id);
          }
        }
        await createSession([sessionNewPayload]);
        setLoading(false);
        handleFormTrigger();
        dispatch({ type: 'removeTimeRange', value: { fieldName: `${'sessionTimeRange'}-${sessionDate}-${id}` } });
        dispatch({ type: 'removeFiles', value: { fieldName: `${'sessionBroucher'}-${sessionDate}-${id}` } });
      } catch (err) {
        setLoading(false);
        console.error('Error creating session:', err);
        
        // Show user-friendly error message
        if (err instanceof Error) {
          enqueueSnackbar(err.message, { variant: 'error' });
        } else {
          enqueueSnackbar('Failed to create session. Please check your inputs and try again.', { variant: 'error' });
        }
      }
    } else {
      enqueueSnackbar('Please fix the errors in the form before submitting.', { variant: 'error' });
    }
  };

  const handleAddSessions = () => {
    const formData = [...sessionDetailsData[sessionDate].sessions]
      .map((items) => {
        const newSpeaker = items.speakers.map((speakers: any) => {
          return { ...speakers, edit: false };
        });
        return { ...items, edit: false, speakers: newSpeaker };
      })
      .concat({
        edit: true,
        sessionId: generateUniqueKey(),
        speakers: [
          {
            speakerId: generateUniqueKey(),
            edit: true,
          },
        ],
      });
    const newData = { ...sessionDetailsData, [sessionDate]: { sessions: formData } };
    setSessionDetailsData(newData);
  };

  const handleAddSpeakers = () => {
    const formatData = [...sessionDetailsData[sessionDate].sessions];
    const newData = formatData.map((items: any) => {
      return {
        ...items,
        speakers: items.speakers
          .map((speaker: any) => ({ ...speaker, edit: false }))
          .concat({
            edit: true,
            speakerId: generateUniqueKey(),
          }),
      };
    });
    setSessionDetailsData((prev: any) => ({
      ...prev,
      [sessionDate]: { sessions: newData },
    }));
  };

  const handleEditSesssion: (id: string) => void = (id: string) => {
    let customSessionDetails = [...sessionDetailsData[sessionDate].sessions]
      .map((items) => {
        if (items.id === id) {
          items['edit'] = true;
        } else {
          items['edit'] = false;
        }

        const newSpeaker = items.speakers.map((speakers: any) => {
          return { ...speakers, edit: false };
        });

        return { ...items, speakers: newSpeaker };
      })
      .filter((items) => {
        return Object.keys(items).length > 3;
      });

    const newArray = { ...sessionDetailsData, [sessionDate]: { sessions: customSessionDetails } };
    setSessionDetailsData(newArray);
  };

  const handleEditSpeaker: (items: any, id: string, mainId: string) => void = (items: any, id: string, mainId: string) => {
    let customSessionDetails = [...sessionDetailsData[sessionDate].sessions].map((subSpeakers: any) => {
      const newSpeakers = subSpeakers.speakers.filter((speaker: any) => {
        if (items?.speakerId === speaker?.speakerId && subSpeakers?.sessionId === mainId) {
          speaker['edit'] = true;
        } else {
          speaker['edit'] = false;
        }

        return Object.keys(speaker).length > 2;
      });

      return { ...subSpeakers, speakers: newSpeakers };
    });

    const newArray = { ...sessionDetailsData, [sessionDate]: { sessions: customSessionDetails } };
    setSessionDetailsData(newArray);
  };

  const handleCustomFormTemplates: (form: any[], id: string, date?: string) => Array<any> = (form, id, date) => {
    let customFormDetails: any = structuredClone(form);
    for (let i = 0; i < customFormDetails.length; i++) {
      let rows = customFormDetails[i].rows;
      for (let j = 0; j < rows.length; j++) {
        let fields = rows[j].fields;
        for (let k = 0; k < fields.length; k++) {
          let field = fields[k];
          if (!field.originalName) {
            field.originalName = field.name;
          }
          field.name = `${field.originalName}-${date}-${id}`;
          if (field?.rule) {
            if (!field?.rule?.originalKey) {
              field.rule.originalKey = field?.rule?.key;
            }
            field.rule.key = `${field?.rule?.originalKey}-${date}-${id}`;
          }
        }
      }
    }

    return customFormDetails;
  };

  const handleFeeSelection: (items: any) => void = (items) => {
    handleFeeTypeModal();
    setFeeType(items.value);
    handleNextStepper();
  };

  const cutsomSessionDetails = (sessionDetailsData[sessionDate] || {})?.sessions || {};
  const isLastRecordOnlyHasIdSession = Object.keys(cutsomSessionDetails[cutsomSessionDetails.length - 1] || {}).length === 3;

  const showValueBasedOnType = (subItems: any, id: number, items: any, type: 'SPEAKER' | 'SESSION') => {
    if (subItems?.type === 'upload') {
      return (
        <Typography color={KenColors.ClientBlack2} fontSize={'16px'} fontWeight={'500'} component={'a'} target="_blank" href={subItems?.value?.data ? subItems?.value?.data : subItems?.value}>
          {shrinkTextBased(20, subItems?.value?.name ? subItems?.value?.name : subItems?.value)}
        </Typography>
      );
    } else if (subItems?.type === 'select' && subItems?.optionsMeta?.objectName !== '') {
      const find = options[subItems?.optionsMeta?.objectName]?.find((items) => {
        return items?.value === subItems?.value;
      });
      return (
        <Typography color={KenColors.ClientBlack2} fontSize={'16px'} fontWeight={'500'}>
          {find?.label}
        </Typography>
      );
    } else if (subItems?.type === 'timeRange') {
      const names = subItems?.name;
      const getData = sessionDetailsData[sessionDate].sessions?.find((items: any, index: number) => {
        return type === 'SESSION' ? items?.sessionId === id : index === id;
      });

      return (
        <Typography color={KenColors.ClientBlack2} fontSize={'16px'} fontWeight={'500'}>
          {`${moment(getData[names[0]], 'HH:mm:ss.SSS[Z]').format('hh:mm A')}-${moment(getData[names[1]], 'HH:mm:ss.SSS[Z]').format('hh:mm A')}`}
        </Typography>
      );
    } else if (subItems?.type === 'array') {
      const customContactArray: any = [];
      const sessionData = sessionDetailsData[sessionDate].sessions?.find((items: any, index: number) => {
        return type === 'SESSION' ? items?.sessionId === id : index === id;
      });
      for (let i = 0; i < (sessionData?.Event_Session_Account_Associations__r?.records || []).length; i++) {
        const element = sessionData.Event_Session_Account_Associations__r.records[i];
        customContactArray.push(element?.Contact__r?.Name || '-');
      }
      return (
        <Box component={'div'} className="d-flex gap-1 align-items-center">
          {customContactArray.map((contacts: string, index: number) => {
            return (
              <Typography color={KenColors.ClientBlack2} fontSize={'16px'} fontWeight={'500'}>
                {`${contacts}${items?.Event_Session_Account_Associations__r?.records.length !== index + 1 ? ', ' : ''}`}
              </Typography>
            );
          })}
        </Box>
      );
    } else {
      return (
        <Typography color={KenColors.ClientBlack2} fontSize={'16px'} fontWeight={'500'}>
          {subItems?.value}
        </Typography>
      );
    }
  };

  const SessionFooterAction: React.FunctionComponent<any> = ({ customSessionForms, items }) => {
    return (
      <Grid container spacing={2}>
        <Grid xs={6}>
          <Typography sx={{ fontSize: '12px', fontWeight: 400, color: '#8A8A8A', margin: '30px 20px 20px 20px' }}>*Save session details to add another session to the day</Typography>
        </Grid>
        <Grid xs={6} display={'flex'} justifyContent={'end'}>
          <AppButton
            variant="contained"
            type="button"
            others={{
              color: KenColors.ClientBlue7,
              border: 'none',
              margin: '20px 15px',
              borderRadius: '8px',
            }}
            border="none"
            background={KenColors.ClientBlue}
            onClick={async () => {
              const isEverySpeakerEmpty = items?.speakers.every((items: any) => {
                return Object.keys(items).length === 2;
              });
              if (isEverySpeakerEmpty) {
                return enqueueSnackbar('Please add atleast one speaker record!', { variant: 'error' });
              }
              await handleCreateSessions(customSessionForms, items?.sessionId, items);
            }}
          >
            Save session details
          </AppButton>
        </Grid>
      </Grid>
    );
  };

  const SpeakerFooterAction: React.FunctionComponent<any> = ({ customSpeakerDetails, mainIndex, speakerId }) => {
    return (
      <Grid container spacing={2}>
        <Grid xs={6}>
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 400,
              color: '#8A8A8A',
              margin: '30px 20px 20px 20px',
            }}
          >
            *Save speaker details to add another speaker to the session
          </Typography>
        </Grid>
        <Grid xs={6} display={'flex'} justifyContent={'end'}>
          <AppButton
            variant="contained"
            type="button"
            others={{
              color: KenColors.ClientBlue7,
              border: 'none',
              margin: '20px',
              borderRadius: '8px',
            }}
            border="none"
            background={KenColors.ClientBlue}
            onClick={async () => {
              await handleCreateSpeakers(customSpeakerDetails, mainIndex, speakerId);
            }}
          >
            Save speaker details
          </AppButton>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      {loading && <KenLoader />}
      {/* Fee type */}
      <Dialog
        open={feeTypeModal}
        onClose={() => {
          handleFeeTypeModal();
        }}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '12px',
            minWidth: isMobile ? '90vw' : '500px',
            width: isMobile ? '90vw' : 'auto',
            margin: isMobile ? '0' : undefined,
          },
        }}
      >
        <Box
          component={'div'}
          className="d-flex flex-column"
          gap={isMobile ? '20px' : '36px'}
          padding={isMobile ? '16px' : '24px'}
          minWidth={isMobile ? 'unset' : '500px'}
          width={isMobile ? '90vw' : 'auto'}
        >
          <Typography
            color={KenColors.ClientBlack2}
            fontSize={isMobile ? '16px' : '18px'}
            fontWeight={'500'}
          >
            How would you like to proceed?
          </Typography>
          <Box
            component={'div'}
            className="d-flex flex-column"
            gap={isMobile ? '8px' : '12px'}
          >
            {feeOptions.map((items, index) => {
              return (
                <Box
                  component={'div'}
                  key={index}
                  className={isMobile ? "d-flex flex-column align-items-start" : "d-flex justify-content-between align-items-center"}
                  sx={{
                    padding: isMobile ? '12px' : '18px',
                    borderRadius: '12px',
                    background: KenColors.ClientBlue,
                    border: feeType === items.value ? `2px solid ${KenColors.ClientBlue7}` : '2px solid transparent',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    handleFeeSelection(items);
                  }}
                >
                  <Typography
                    color={KenColors.ClientBlack1}
                    fontSize={isMobile ? '12.5px' : '13.5px'}
                    fontWeight={'400'}
                  >
                    {items.label}
                  </Typography>
                  {feeType === items.value && (
                    <CheckCircleRoundedIcon style={{ color: KenColors.ClientBlue7, marginLeft: isMobile ? 0 : 8, marginTop: isMobile ? 8 : 0 }} />
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>
      </Dialog>
      {/* New contact */}
      <Dialog
        open={newContact}
        onClose={() => {
          handleNewContact();
        }}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '12px',
          },
        }}
      >
        <Box component={'div'} className="d-flex flex-column" gap={'12px'} padding={'24px'} minWidth={'500px'}>
          <Grid container>
            <Grid item xs={11}>
              <Typography className={eventClasses.pricingDateTitle} color={'#333333'}>
                Create contact
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <CloseIcon onClick={closeNewContact} />
            </Grid>
          </Grid>
          <Controller
            name="email"
            control={contactControl}
            rules={{
              required: 'This field is required',
              pattern: { value: REGEX.EMAIL, message: 'Please enter a valid email' },
            }}
            render={({ field: { value, onChange }, fieldState: { error } }) => {
              return (
                <KenInput
                  border
                  customMargin
                  labelClassName={classes.inputLableCustom}
                  onChange={onChange}
                  label={'Email'}
                  value={value}
                  required
                  placeholder={'Enter your email address'}
                  error={error?.message}
                  errorMessage={error?.message}
                  InputProps={{ className: classes.inputStyles }}
                />
              );
            }}
          />
          <Controller
            name="lastName"
            control={contactControl}
            rules={{
              required: 'This field is required',
              pattern: {
                value: REGEX.NAME,
                message: 'Please enter a valid name',
              },
              maxLength: {
                value: 20,
                message: 'This field cannot be more than 20 characters',
              },
            }}
            render={({ field: { value, onChange }, fieldState: { error } }) => {
              return (
                <KenInput
                  border
                  customMargin
                  labelClassName={classes.inputLableCustom}
                  onChange={onChange}
                  value={value}
                  label={'Name'}
                  placeholder={'Enter your name'}
                  required
                  error={error?.message}
                  errorMessage={error?.message}
                  InputProps={{ className: classes.inputStyles }}
                />
              );
            }}
          />
          <Box component={'div'} className="d-flex justify-content-end w-100">
            <AppButton
              onClick={() => {
                handleCreateNewContact(contactValues());
              }}
              size="medium"
              variant="contained"
            >
              Create Contact
            </AppButton>
          </Box>
        </Box>
      </Dialog>
      <Box component={'div'} padding={'10px 0px'}>
        <Box component={'div'} className="d-flex flex-nowrap" gap={'8px'}>
          {selectedDate &&
            Object.keys(selectedDate).map((items: string, index: number) => {
              const hasdata = sessionDate === items;
              return hasdata ? (
                <AppButton
                  fullWidth
                  key={index}
                  size="small"
                  border="none"
                  variant="contained"
                  onClick={() => {
                    handleChangeDate(items);
                  }}
                >
                  {moment(items).format('DD MMM, YYYY')}
                </AppButton>
              ) : (
                <AppButton
                  fullWidth
                  key={index}
                  size="small"
                  variant="contained"
                  background={KenColors.ClientBlue}
                  others={{
                    color: KenColors.ClientBlack1,
                    border: 'none',
                  }}
                  onClick={() => {
                    handleChangeDate(items);
                  }}
                >
                  {moment(items).format('DD MMM, YYYY')}
                </AppButton>
              );
            })}
        </Box>
        {/* Session Details */}
        {sessionDate &&
          (sessionDetailsData[sessionDate].sessions || []).map((items: any, mainIndex: number) => {
            let customSessionForms = handleCustomFormTemplates(sessionDetails, items?.sessionId, sessionDate);
            let customLocationdetails = handleCustomFormTemplates(locationDetails, items?.sessionId, sessionDate);
            let customSpeakerDetails: any[] = [];
            const showDataArray = [];

            for (let i = 0; i < [...customSessionForms, ...locationDetails].length; i++) {
              const fieldsToShow = [...customSessionForms, ...locationDetails][i]?.metaData?.fieldsToShow || [];
              for (let j = 0; j < fieldsToShow.length; j++) {
                const fields = fieldsToShow[j];
                showDataArray.push({ ...fields, label: fields.label, value: items[fields.name] });
              }
            }

            let speakerDetailsData: any = items?.speakers || [];
            const updatedSpeakerDetails = [...speakerDetailsData].sort((a: any, b: any) => {
              if (Object.keys(a).length === 0) return 1;
              if (Object.keys(b).length === 0) return -1;
              return 0;
            });

            const isLastRecordOnlyHasId = Object.keys(updatedSpeakerDetails[updatedSpeakerDetails.length - 1] || {}).length === 2;

            return (
              <>
                {items?.edit ? (
                  <Box key={mainIndex}>
                    {/* Session Details */}
                    <Typography color={KenColors.kenBlack} fontSize={'15px'} fontWeight={'500'} margin={'20px 0px'}>
                      Session details
                    </Typography>
                    <FormBuilder formJson={customSessionForms} />
                    {/* Speakers */}
                    <Typography color={KenColors.kenBlack} fontSize={'15px'} fontWeight={'500'} margin={'20px 0px'}>
                      Speaker details
                    </Typography>

                    {updatedSpeakerDetails.map((speaker: any, index: number) => {
                      const speakerShowArray = [];

                      customSpeakerDetails = handleCustomFormTemplates(speakerDetails, speaker?.speakerId, sessionDate);

                      // Update the speakerName field options with the contacts data
                      customSpeakerDetails = customSpeakerDetails.map((formSection: any) => ({
                        ...formSection,
                        rows: formSection.rows.map((row: any) => ({
                          ...row,
                          fields: row.fields.map((field: any) => {
                            console.log('Field being processed:', field.name, 'Original name:', field.originalName);
                            // Check if this is a speakerName field (the name will be like 'speakerName-2025-02-18-abc123')
                            if (field.name.includes('speakerName') || field.originalName === 'speakerName') {
                              console.log('Found speakerName field, updating with contacts:', allContacts);
                              return {
                                ...field,
                                options: allContacts || [], // Pass the contacts as options
                              };
                            }
                            return field;
                          }),
                        })),
                      }));

                      console.log('Final customSpeakerDetails with contacts:', customSpeakerDetails);

                      for (let i = 0; i < speakerDetails.length; i++) {
                        const rows = speakerDetails[i].rows;
                        for (let j = 0; j < rows.length; j++) {
                          const fields = rows[j].fields;
                          for (let k = 0; k < fields.length; k++) {
                            const field = fields[k];
                            if (Object.keys(speaker).length > 0) {
                              if (field.type === 'upload') {
                                speakerShowArray.push({
                                  ...field,
                                  value: files[`${field.name}-${sessionDate}-${speaker?.speakerId}`]
                                    ? files[`${field.name}-${sessionDate}-${speaker?.speakerId}`]
                                    : speaker[`${field.name}-${sessionDate}-${speaker?.speakerId}`],
                                });
                              } else {
                                speakerShowArray.push({ ...field, value: speaker[`${field.name}-${sessionDate}-${speaker?.speakerId}`] });
                              }
                            }
                          }
                        }
                      }

                      return speaker?.edit ? (
                        <>
                          {/* Render the form for the last speaker */}
                          <FormBuilder 
                            key={`speaker-${speaker?.speakerId}-${allContacts.length}`} 
                            formJson={customSpeakerDetails} 
                          />
                          {isLastRecordOnlyHasId ? (
                            <SpeakerFooterAction speakerId={speaker?.speakerId} mainIndex={mainIndex} customSpeakerDetails={customSpeakerDetails} />
                          ) : speaker?.edit ? (
                            <SpeakerFooterAction speakerId={speaker?.speakerId} mainIndex={mainIndex} customSpeakerDetails={customSpeakerDetails} />
                          ) : null}
                        </>
                      ) : (
                        <Box
                          component={'div'}
                          sx={{
                            background: KenColors.ClientGrey2,
                            borderRadius: '12px',
                            padding: '20px',
                            margin: '10px 0px',
                          }}
                        >
                          <Box
                            className="d-flex justify-content-between align-items-center"
                            sx={{
                              flexDirection: isMobile ? 'column' : 'row',
                              alignItems: isMobile ? 'flex-start' : 'center',
                              gap: isMobile ? '12px' : 0,
                            }}
                          >
                            <Typography color={KenColors.ClientBlack2} fontSize={'16px'} fontWeight={'500'}>
                              Speaker {index + 1}
                            </Typography>
                            <Box
                              className="d-flex gap-3"
                              sx={{
                                flexDirection: 'row',
                                marginTop: isMobile ? '8px' : 0,
                              }}
                            >
                              <IconButton
                                sx={{
                                  background: KenColors.ClientRed2,
                                  borderRadius: '8px',
                                  padding: '8px 18px',
                                }}
                                onClick={() => {
                                  handleDeleteSpeakers(speaker, speaker?.speakerId);
                                }}
                              >
                                <DeleteOutlineOutlinedIcon
                                  style={{
                                    color: KenColors.ClientRed,
                                    height: '20px',
                                    width: '20px',
                                  }}
                                />
                              </IconButton>
                              <IconButton
                                sx={{
                                  background: KenColors.ClientBlue3,
                                  borderRadius: '8px',
                                  padding: '8px 18px',
                                }}
                                onClick={() => {
                                  handleEditSpeaker(speaker, speaker?.speakerId, items?.sessionId);
                                }}
                              >
                                <EditOutlinedIcon
                                  style={{
                                    color: KenColors.kenWhite,
                                    height: '20px',
                                    width: '20px',
                                  }}
                                />
                              </IconButton>
                            </Box>
                          </Box>
                          <Divider sx={{ margin: '15px 0px' }} />
                          {/* Responsive Speaker Summary */}
                          <Box
                            component={'div'}
                            className="d-flex"
                            gap={isMobile ? '16px' : '40px'}
                            sx={{
                              flexDirection: isMobile ? 'column' : 'row',
                              alignItems: isMobile ? 'stretch' : 'flex-start',
                              width: '100%',
                            }}
                          >
                            {speakerShowArray.map((subItems: any, subIndex: number) => (
                              <Box
                                component={'div'}
                                className="d-flex flex-column"
                                gap={'6px'}
                                key={subIndex}
                                sx={{
                                  background: isMobile ? KenColors.ClientGrey2 : 'transparent',
                                  borderRadius: isMobile ? '8px' : 0,
                                  padding: isMobile ? '12px' : 0,
                                  width: isMobile ? '100%' : 'auto',
                                }}
                              >
                                <Typography color={KenColors.ClientGrey} fontSize={isMobile ? '13px' : '14px'} fontWeight={'500'}>
                                  {subItems?.label}
                                </Typography>
                                {showValueBasedOnType(subItems, mainIndex, items, 'SPEAKER')}
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      );
                    })}

                    {!isLastRecordOnlyHasId && (
                      <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                        <AppButton
                          variant="contained"
                          type="button"
                          others={{
                            color: KenColors.ClientBlue7,
                            border: 'none',
                            margin: '20px 0px',
                            borderRadius: '8px',
                          }}
                          border="none"
                          background={KenColors.ClientBlue}
                          onClick={() => handleAddSpeakers()}
                        >
                          + Add Speaker
                        </AppButton>
                      </Box>
                    )}
                    
                    <Typography color={KenColors.kenBlack} fontSize={'15px'} fontWeight={'500'} margin={'20px 0px'}>
                      Location details
                    </Typography>

                    {/* Location details */}
                    {customLocationdetails?.[0]?.rows?.map((fields: any) => {
                      const fieldss = fields?.fields?.[0];
                      const watchedLocationType = watch(fieldss?.rule?.key);

                      if (fields?.fields?.[0]?.type == 'radio') {
                        const customOptions = fields?.fields?.[0]?.radioOptions;
                        fields = fields?.fields?.[0];

                        return (
                          <div style={{ ...fields.fieldStyle }} key={fields.name}>
                            <Controller
                              control={control}
                              render={({ field: { onChange, value }, fieldState: { error } }) => (
                                <>
                                  {fields.hideLabel && <KenTextLabel label={fields.label} labelClassName={classes.inputLableCustom} />}
                                  <RadioGroup
                                    onChange={(_, value) => {
                                      onChange(value);
                                    }}
                                    value={value}
                                    {...fields.radioGroupProps}
                                  >
                                    {customOptions?.map((items: any, index: any) => (
                                      <FormControlLabel
                                        sx={{
                                          '& .MuiTypography-root': {
                                            fontSize: '1rem',
                                            '@media (max-width: 1440px)': {
                                              fontSize: '0.9rem',
                                            },
                                          },
                                        }}
                                        value={items.value}
                                        control={<Radio />}
                                        label={items.label}
                                        key={index}
                                      />
                                    ))}
                                  </RadioGroup>
                                </>
                              )}
                              {...registers(`${fields.name}`, { ...fields?.validation })}
                            />
                          </div>
                        );
                      } else if (watchedLocationType === fieldss?.rule?.value) {
                        return (
                          <Grid container spacing={2} mt={0.5}>
                            <Grid item xs={6}>
                              <div style={{ ...fields.fieldStyle }}>
                                <Controller
                                  control={control}
                                  render={({ field: { onChange, value }, fieldState: { error } }) => {
                                    return (
                                      <KenInput
                                        border
                                        customMargin
                                        labelClassName={classes.inputLableCustom}
                                        onChange={(event: any) => {
                                          onChange(event);
                                        }}
                                        value={value}
                                        error={error?.message}
                                        errorMessage={error?.message}
                                        InputProps={{ className: classes.inputStyles }}
                                        {...fieldss}
                                      />
                                    );
                                  }}
                                  {...registers(`${fieldss.name}`, { ...fieldss?.validation })}
                                />
                              </div>
                            </Grid>
                          </Grid>
                        );
                      }
                    })}

                    {isLastRecordOnlyHasIdSession ? (
                      <SessionFooterAction customSessionForms={[...customSessionForms, ...customLocationdetails]} items={items} />
                    ) : items?.edit ? (
                      <SessionFooterAction customSessionForms={[...customSessionForms, ...customLocationdetails]} items={items} />
                    ) : null}
                  </Box >
                ) : (
                  <Box component={'div'} sx={{ background: KenColors.ClientGrey2, borderRadius: '12px', padding: '20px', margin: '10px 0px' }}>
                    <div className="d-flex justify-content-between align-items-center">
                      <Typography color={KenColors.ClientBlack2} fontSize={'16px'} fontWeight={'500'}>
                        Session {mainIndex + 1}
                      </Typography>
                      <div className="d-flex gap-3">
                        <IconButton
                          sx={{ background: KenColors.ClientRed2, borderRadius: '8px', padding: '8px 18px' }}
                          onClick={() => {
                            handleDeleteSession(items?.id);
                          }}
                        >
                          <DeleteOutlineOutlinedIcon style={{ color: KenColors.ClientRed, height: '20px', width: '20px' }} />
                        </IconButton>
                        <IconButton
                          sx={{ background: "#4B3776", borderRadius: '8px', padding: '8px 18px' }}
                          onClick={() => {
                            handleEditSesssion(items?.id);
                          }}
                        >
                          <EditOutlinedIcon style={{ color: KenColors.kenWhite, height: '20px', width: '20px' }} />
                        </IconButton>
                      </div>
                    </div>
                    <Divider sx={{ margin: '15px 0px' }} />
                    {/* Responsive Session Summary */}
                    <Box
                      component={'div'}
                      className="d-flex"
                      gap={isMobile ? '16px' : '40px'}
                      sx={{
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: isMobile ? 'stretch' : 'flex-start',
                        width: '100%',
                      }}
                    >
                      {showDataArray.map((subItems: any, subIndex: number) => (
                        <Box
                          component={'div'}
                          className="d-flex flex-column"
                          gap={'6px'}
                          key={subIndex}
                          sx={{
                            background: isMobile ? KenColors.ClientGrey2 : 'transparent',
                            borderRadius: isMobile ? '8px' : 0,
                            padding: isMobile ? '12px' : 0,
                            width: isMobile ? '100%' : 'auto',
                          }}
                        >
                          <Typography
                            color={KenColors.ClientGrey}
                            fontSize={isMobile ? '13px' : '14px'}
                            fontWeight={'500'}
                          >
                            {subItems?.label}
                          </Typography>
                          {showValueBasedOnType(subItems, items?.sessionId, items, 'SESSION')}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
              </>
            );
          })}

        {!isLastRecordOnlyHasIdSession && (
          <Box sx={{ display: 'flex', justifyContent: 'start' }}>
            <AppButton
              variant="contained"
              type="button"
              others={{
                background: "linear-gradient(90deg, #4B3776, #FFE090)",
                color: "#5B4200",
                border: 'none',
                margin: '20px 15px',
                borderRadius: '8px',
              }}
              border="none"
              background={KenColors.ClientBlue}
              onClick={() => {
                handleAddSessions();
              }}
            >
              + Add Session
            </AppButton>
          </Box>
        )}
      </Box >
    </>
  );
};

export default Sessions;
